import $ from 'jquery';
import Promise from 'bluebird';

export function convertSmartToExpertMode({
  ccuiEndpoint,
  customerId,
  accountId,
  userId,
}) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${ccuiEndpoint}Account/ConvertSmartToExpertMode?cid=${customerId}&aid=${accountId}&uid=${userId}`,
      type: 'post',
      dataType: 'json',
      contentType: 'application/json',
      xhrFields: {
        withCredentials: true,
      },
      success(result) {
        resolve(result);
      },
      error(e = {}) {
        if (e.status === 200) {
          resolve();
        } else {
          reject(e);
        }
      },
      converters: {
        'text json': function (result) {
          return result === '' ?
            result : JSON.parse(result);
        },
      },
    });
  });
}
